import React from 'react';
import { Pressable, Text, StyleSheet, ViewStyle } from 'react-native';
import { Paprika } from '../../../../styles/theme';

type Variant = 'normal' | 'glow' | 'faint';

interface Props {
  variant?: Variant;
  onPress?: () => void;
}

export function EmptySlot({ variant = 'normal', onPress }: Props) {
  return (
    <Pressable
      style={[styles.slot, variantStyle[variant]]}
      onPress={onPress}
      disabled={!onPress}
    >
      {variant !== 'faint' && (
        <Text style={[styles.plus, variant === 'glow' ? styles.plusGlow : styles.plusNormal]}>+</Text>
      )}
    </Pressable>
  );
}

const variantStyle: Record<Variant, ViewStyle> = {
  normal: {
    borderStyle: 'dashed',
    borderColor: Paprika.border,
    backgroundColor: 'transparent',
  },
  glow: {
    borderStyle: 'dashed',
    borderColor: Paprika.brandSoft,
    backgroundColor: Paprika.brandTint,
  },
  faint: {
    borderStyle: 'dashed',
    borderColor: Paprika.border,
    backgroundColor: Paprika.bgSunk,
    opacity: 0.25,
  },
};

const styles = StyleSheet.create({
  slot: {
    borderWidth: 1.5,
    borderRadius: 10,
    // Fills the open row of the grid; the closed rows draw SlotMiniCell instead.
    flex: 1,
    minHeight: 88,
    justifyContent: 'center',
    alignItems: 'center',
  },
  plus: {
    fontSize: 20,
    lineHeight: 22,
  },
  plusNormal: {
    color: Paprika.border,
  },
  plusGlow: {
    color: Paprika.primary,
  },
});
